import { getFileSize } from "@/utils/getFileSize";

export const getFormattedFileTypeErrorMessage = (acceptedFileTypes: string) => {
	return `File type must be one of the following: ${acceptedFileTypes.split(",").join(", ")}`;
};

export const getFiletypeLabelFromFileName = (filename?: string): string => {
	if (!filename) {
		return "File";
	}
	const parts = filename.split(".");
	const fileExtension = parts.length > 1 ? parts.pop()?.toUpperCase() : null;
	return fileExtension || "File";
};

export const getFileDownloadButtonLabel = (fileData: any) => {
	return `Download (${getFiletypeLabelFromFileName(fileData?.fileName)}, ${getFileSize(
		parseInt(fileData?.fileSize!!) ?? 0,
	)})`;
};
